import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  html { font-size: 62.5%; scroll-behavior: smooth; scroll-padding-top: 9rem; }
  *, *::before, *::after { box-sizing: border-box; }
  body { margin: 0; min-width: 320px; overflow-x: hidden; background: #F4F1E9; color: #182F35; font-family: 'AvenirNextLTPro-Regular', Arial, sans-serif; font-size: 1.6rem; font-weight: 400; line-height: 1.6; text-rendering: optimizeLegibility; }
  a { color: inherit; text-decoration: none; }
  button, input, select, textarea { font: inherit; }
  img { max-width: 100%; }
  p { letter-spacing: normal; }
  :focus-visible { outline: 3px solid #A47B4F; outline-offset: 4px; border-radius: 2px; }
  ::selection { background: #B5C6C1; color: #182F35; }

  @font-face { font-family: 'AvenirNextLTPro-Regular'; src: url('/fonts/AvenirNextLTPro-Regular.woff2') format('woff2'), url('/fonts/AvenirNextLTPro-Regular.woff') format('woff'); font-weight: 400; font-style: normal; font-display: swap; }
  @font-face { font-family: 'Whyte-Bold'; src: url('/fonts/AvenirNextLTPro-Regular.woff2') format('woff2'); font-weight: 700; font-style: normal; font-display: swap; }

  @media (prefers-reduced-motion: reduce) {
    html { scroll-behavior: auto; }
    *, *::before, *::after { animation-duration: 0.01ms !important; animation-iteration-count: 1 !important; transition-duration: 0.01ms !important; scroll-behavior: auto !important; }
  }
`
